import React from "react";
import cn from "classnames";
import styles from "./Modal.module.scss";
import { twMerge } from "tailwind-merge";
import { Icon } from "../Icon/Icon";
import Button from "../Button";
import { HeadlessUi } from "../headlessUi";
const Modal = React.forwardRef(({ headerClassName, onClose, closeOnBackDrop = false, headerText, className, children, contentClassName, containerClassName, alignment = "center", disableCloseAnimation, dataCySuffix, contentCanBeScrollable = true, }, outerRef) => {
    const [initialOpen, setInitialOpen] = React.useState(true);
    const [isClosing, setIsClosing] = React.useState(false);
    const closeAction = React.useCallback(() => {
        if (!onClose)
            return;
        setInitialOpen(false);
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300);
    }, []);
    const hasHeader = !!headerText;
    const dataCy = dataCySuffix ? `ukt-${dataCySuffix}-modal` : "ukt-modal";
    return (React.createElement(HeadlessUi.Dialog, { static: true, autoFocus: true, className: () => cn("relative z-[999] flex flex-col focus:outline-none", styles.modal, {
            [styles.out]: !initialOpen,
        }, {
            top: styles.topAlignment,
            bottom: styles.bottomAlignment,
            center: styles.centerAlignment,
        }[alignment], className), open: initialOpen, onClose: (v) => {
            if (closeOnBackDrop) {
                closeAction();
            }
        } },
        React.createElement(HeadlessUi.DialogBackdrop, { className: cn("fixed inset-0 bg-[#000a12cc]", styles.backdrop) }),
        React.createElement("div", { className: cn("fixed inset-0 w-screen overflow-y-auto"), style: contentCanBeScrollable
                ? {
                    scrollbarGutter: "stable both-edges",
                }
                : undefined },
            React.createElement("div", { className: twMerge("flex h-full min-h-full justify-center transition-opacity", {
                    top: "items-start",
                    bottom: "items-end",
                    center: "items-center",
                }[alignment]) },
                React.createElement(HeadlessUi.DialogPanel, { "data-cy": dataCy, onClick: (e) => e.stopPropagation(), className: cn(twMerge("max-h-full w-max min-w-[400px] max-w-full", styles.container, containerClassName)) },
                    hasHeader && (React.createElement("div", { className: twMerge("typography-h2 flex items-center justify-between text-on-main-color", "mb-[-10px] rounded-t-[16px] bg-main-color px-8 pt-5 pb-[30px]", headerClassName, styles.header) },
                        React.createElement(HeadlessUi.DialogTitle, null, headerText),
                        onClose && (React.createElement(Button, { ariaLabel: `Close Modal`, kind: "icon", color: "white", onClick: closeAction },
                            React.createElement(Icon, { className: "icon big-cross-icon icon-lg " }))))),
                    React.createElement("div", { className: twMerge("overflow-hidden bg-card-color px-8 py-6", {
                            top: "rounded-b-[10px]",
                            bottom: "rounded-t-[10px]",
                            center: "rounded-[10px]",
                        }[alignment], contentClassName) }, children))))));
});
export default Modal;
//# sourceMappingURL=Modal.js.map